import { Feature } from "ol";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { useEffect } from "react";
import { Icon } from "ol/style";


import { useMap } from "./Context";

interface GenericMarkerProps {
  coordinates?: [number, number] | null,
  img?: string,
  size?: number,
  anchor?: [number, number]
}

const GenericMarker: React.FC<GenericMarkerProps> = ({ coordinates, img, size, anchor }) => {

  const { map } = useMap();

  useEffect(() => {
    if (!map) return;

    // Create a feature with a Point geometry
    const markerFeature = new Feature({
      geometry: coordinates ? new Point(fromLonLat(coordinates)) : undefined, // Convert to map projection
    });

    // Apply a circular style to the feature
    markerFeature.setStyle(
      new Style({
        image: new Icon({
          src: img, // Marker icon
          scale: size,
          anchor: anchor || [0.5, 0.5], // Anchor point for the icon
        }),
      })
    );

    // Create a vector source and add the feature
    const vectorSource = new VectorSource({
      features: [markerFeature],
    });

    // Create a vector layer and add it to the map
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    // Add the layer to the map
    //map.removeLayer(vectorLayer);
    map.addLayer(vectorLayer);

    // Cleanup function
    return () => {
      map.removeLayer(vectorLayer);
    };

  }, [map, coordinates, img, size]);

  return null;
};

export default GenericMarker;